import { drawSpatialFieldRgb } from '../canvasUtils';

const S = 0;
const I = 1;
const R = 2;
const COLORS = ['#2cbb5d', '#ef4743', '#4fc3f7'];

function initEpidemic(n, params) {
    const grid = new Uint8Array(n * n);
    for (let i = 0; i < n * n; i++) grid[i] = S;
    let placed = 0;
    while (placed < params.initialInfected) {
        const idx = Math.floor(Math.random() * n * n);
        if (grid[idx] === S) {
            grid[idx] = I;
            placed += 1;
        }
    }
    return { n, grid, t: 0, infected: placed, recovered: 0 };
}

function countState(grid, state) {
    let c = 0;
    for (let i = 0; i < grid.length; i++) if (grid[i] === state) c += 1;
    return c;
}

function stepEpidemic(state, params) {
    const { n, grid } = state;
    const next = new Uint8Array(grid);

    for (let i = 0; i < n * n; i++) {
        if (grid[i] === I && Math.random() < params.recoveryRate) {
            next[i] = R;
        }
    }

    for (let i = 0; i < n * n; i++) {
        if (grid[i] !== I) continue;
        const x = i % n;
        const y = Math.floor(i / n);
        for (let dy = -1; dy <= 1; dy++) {
            for (let dx = -1; dx <= 1; dx++) {
                if (dx === 0 && dy === 0) continue;
                const ni = ((y + dy + n) % n) * n + ((x + dx + n) % n);
                if (grid[ni] === S && Math.random() < params.infectionRate) {
                    next[ni] = I;
                }
            }
        }
    }

    state.grid = next;
    state.infected = countState(next, I);
    state.recovered = countState(next, R);
    state.t += 1;
}

export const epidemicGrid = {
    init: (w, h, params) => initEpidemic(56, params),
    step: (ctx, w, h, state, params) => {
        for (let k = 0; k < params.stepsPerFrame; k++) {
            stepEpidemic(state, params);
        }
        const { n, grid } = state;
        drawSpatialFieldRgb(ctx, w, h, n, (idx) => COLORS[grid[idx]], {
            xLabel: 'x (population)',
            yLabel: 'y (population)',
            title: `SIR lattice | infected ${state.infected} recovered ${state.recovered}`,
            t: state.t,
        });
    },
};

export const epidemicSIR = {
    init: (w, h, params) => {
        const base = initEpidemic(56, params);
        base.sHistory = [];
        base.iHistory = [];
        base.rHistory = [];
        return base;
    },
    step: (ctx, w, h, state, params) => {
        stepEpidemic(state, params);
        const n = state.n;
        const total = n * n;
        const s = countState(state.grid, S);
        state.sHistory.push(s / total);
        state.iHistory.push(state.infected / total);
        state.rHistory.push(state.recovered / total);
        if (state.sHistory.length > 400) {
            state.sHistory.shift();
            state.iHistory.shift();
            state.rHistory.shift();
        }

        drawSpatialFieldRgb(ctx, w, h, n, (idx) => COLORS[state.grid[idx]], {
            xLabel: 'x (population)',
            yLabel: 'y (population)',
            title: `Spatial SIR epidemic`,
            t: state.t,
        });
    },
};
